import React from 'react';

function ViewBooking({ book, closeModal }) {
  if (!book) return null;

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'Invalid Date';
    }
  
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();
  
    return `${day}-${month}-${year}`;
  };
  const url = 'uploads/';
  const { date, time } = formatDateTime(book.createdAt);

  return (
    <div className="modal fade viewbox edit-box show d-block" id="manufacturerModal" tabIndex={-1} aria-labelledby="manufacturerModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="manufacturerModal">Booking Details</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            
            <div className="container">
                <div className="d-flex" style={{gap: "15px"}}>
                    <div className="container-box user-manager" style={{ padding: "10px", marginTop: "0", flex: "1"}}>
                    <ul className='user-details list-unstyled d-flex justify-content-between'>
                        <li className='text-start'>
                            <span>Booking ID: </span>
                            <span>{book?.bookingId || 'N/A'}</span>
                            </li>
                        </ul>
                    </div>
                    <div className="container-box user-manager" style={{ padding: "10px", marginTop: "0", flex: "1" }}>
                        <ul className='user-details list-unstyled d-flex justify-content-between'>
                            <li className='text-start'>
                            <span>Transportation: </span>
                            <span>{book?.transport ? 'Yes' : 'No'}</span>
                            </li>
                        </ul>
                    </div>
                </div>

              {/* User Info Section */}
                <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                    <h4>User Information:</h4>
                  <ul className='user-details list-unstyled d-flex justify-content-between'>
                    <li>
                      <span>Name</span>
                      <p>{book?.user?.name || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Email</span>
                      <p>{book?.user?.email || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Phone</span>
                      <p>{book?.user?.mobileNo || 'N/A'}</p>
                    </li>
                  </ul>
                </div>
                <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                    <h4>Cottage Information:</h4>
                  <ul className='user-details list-unstyled d-flex justify-content-between'>
                    <li>
                      <span>Cottage Name</span>
                      <p>{book?.cottage?.name || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Location</span>
                      <p>{book?.cottage?.location || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Capacity</span>
                      <p>{book?.cottage?.guestCapacity || 'N/A'}</p>
                    </li>
                  </ul>
                </div>
                <div className="container-box user-manager" style={{ padding: "10px", marginTop: "15px" }}>
                  <ul className='user-details list-unstyled d-flex justify-content-between'>
                    <li>
                      <span>Check-in Date</span>
                      <p>{formatDate(book?.checkInDate) || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Check-out Date</span>
                      <p>{formatDate(book?.checkOutDate) || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Total Amount</span>
                      <p>₹{book?.totalAmount || 'N/A'}</p>
                    </li>
                  </ul>
                  <ul className='user-details list-unstyled d-flex justify-content-between'>
                    <li>
                      <span>Discount</span>
                      <p>₹{book?.discountAmount || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Taxes</span>
                      <p>{book?.tax || 'N/A'}%</p>
                    </li>
                    <li>
                      <span>Guest</span>
                      <p>{book?.guestDetails.length || 'N/A'}</p>
                    </li>
                  </ul>
                  <ul className='user-details list-unstyled d-flex justify-content-between'>
                    <li>
                      <span>Payment Method</span>
                      <p>{book?.paymentmethod || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Payment Status</span>
                      <p>{book?.paymentStatus || 'N/A'}</p>
                    </li>
                    <li>
                      <span>Status</span>
                      <p>₹{book?.status || 'N/A'}</p>
                    </li>
                  </ul>
                  <ul className='user-details list-unstyled d-flex'>
                    <li className='text-start'>
                      <span>Coupon Code</span>
                      <p>{book?.coupon?.name || 'N/A'}</p>
                    </li>
                  </ul>
                </div>
                <div className="modal-footer d-flex">
            <button type="button" className="site-btn-green" style={{ marginBlock: '15px' }} onClick={closeModal}>
              CLOSE
            </button>
          </div>
            
            </div>

     
    </div>
        </div>
     
      </div>
    </div>
  );
}

export default ViewBooking;
